<template>
  <div class="head_bar">
    <div class="cloum">
      <div class="bar_left">
        <!-- <div class="bar_log"></div> -->
        <div class="bar_title" @click="toIndex1">
          <img src="../../assets/imgs/logo-new.jpg" alt="" />
        </div>
        <div class="bar_span">
          <span>Minder Inspection</span>
        </div>
      </div>

      <div class="bar_nav">
        <div class="m-head-nav">
          <!-- <ul
            :class="
              index == '1' ? 'm-head-nav-item curActiveLi' : 'm-head-nav-item '
            "
            @click.stop="goUrl(1, 1)"
          >
            {{
              $t('lang.BarOther.home')
            }}
          </ul>
          
          <ul
            :class="
              index == '2' ? 'm-head-nav-item curActiveLi' : 'm-head-nav-item'
            "
          >
            <li class="drop-li">
              {{ $t('lang.BarOther.service') }} +
              <div class="drop-div">
                <ul >
                  <li
                    :class="
                      index == '2' && cIndex == '2'
                        ? 'm-head-nav-item  curActiveLi'
                        : 'm-head-nav-item'
                    "
                    @click.stop="goUrl(2, 2)"
                  >
                    {{ $t('lang.BarOther.quality') }}
                  </li>
                  <li
                    :class="
                      index == '2' && cIndex == '3'
                        ? 'm-head-nav-item  curActiveLi'
                        : 'm-head-nav-item'
                    "
                    @click.stop="goUrl(2, 3)"
                  >
                    {{ $t('lang.BarOther.rkkw9t') }}
                  </li>
                  <li
                    :class="
                      index == '2' && cIndex == '4'
                        ? 'm-head-nav-item  curActiveLi'
                        : 'm-head-nav-item'
                    "
                    @click.stop="goUrl(2, 4)"
                  >
                    {{ $t('lang.BarOther.oww1lo') }}
                  </li>
                  <li
                    :class="
                      index == '2' && cIndex == '5'
                        ? 'm-head-nav-item  curActiveLi'
                        : 'm-head-nav-item'
                    "
                    @click.stop="goUrl(2, 5)"
                  >
                    {{ $t('lang.BarOther.vwiq99') }}
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <ul
            :class="
              index != '3' ? 'm-head-nav-item' : 'm-head-nav-item curActiveLi'
            "
          >
            <li @click.stop="goUrl(3, 1)">{{ $t('lang.BarOther.fuaoau') }}</li>
          </ul>
          <ul
            @click.stop="goUrl(4, 1)"
            :class="
              index != '4' ? 'm-head-nav-item' : 'm-head-nav-item curActiveLi'
            "
          >
            FAQ
          </ul>
          <ul
            @click.stop="goUrl(5, 1)"
            :class="
              index != '5' ? 'm-head-nav-item' : 'm-head-nav-item curActiveLi'
            "
          >
            {{
              $t('lang.BarOther.q618ep')
            }}
          </ul>
          <ul class="m-head-nav-item" @click.stop="changeLanguage">
            {{
              $t('lang.BarOther.b2xprb')
            }}
          </ul> -->
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="1"
              >{{ $t('lang.BarOther.home') }}
            </el-menu-item>
            <el-submenu index="22" style="background-color: '';">
              <template slot="title">
                {{ $t('lang.BarOther.service') }} +</template
              >
              <el-menu-item index="2"  style="background-color: '';" >
                {{ $t('lang.BarOther.quality') }}
              </el-menu-item>
              <el-menu-item index="3">
                {{ $t('lang.BarOther.rkkw9t') }}
              </el-menu-item>
              <el-menu-item index="4">
                {{ $t('lang.BarOther.oww1lo') }}
              </el-menu-item>
              <el-menu-item index="5">
                {{ $t('lang.BarOther.vwiq99') }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="6">
              {{ $t('lang.BarOther.fuaoau') }}
            </el-menu-item>
            <el-menu-item index="7"> FAQ </el-menu-item>
            <el-menu-item index="8">
              {{ $t('lang.BarOther.q618ep') }}
            </el-menu-item>
            <el-menu-item index="10" @click.stop="changeLanguage">
              {{ $t('lang.BarOther.b2xprb') }}
            </el-menu-item>
          </el-menu>
        </div>

        <div class="m-head-nav-btn" @click="openurl">
          {{ $t('lang.BarOther.iqp9rr') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../js/api';

export default {
  name: 'bar',
  data() {
    return {
      activeIndex: this.$route.query.navIndex,

      realname: '',
      loginFlag: false,
      imgpath: '',
      total: 0,
    };
  },
  mounted() {},
  methods: {
    changeLanguage() {
      if (this.$i18n.locale === 'en-US') {
        this.$i18n.locale = 'zh-CN'; //关键语句
        console.log('zh:', this.$i18n.locale);
        sessionStorage.setItem('lang', JSON.stringify(this.$i18n.locale || ''));
      } else {
        this.$i18n.locale = 'en-US'; //关键语句
        console.log('en:', this.$i18n.locale);
        sessionStorage.setItem('lang', JSON.stringify(this.$i18n.locale || ''));
      }
    },
    openurl() {
      window.open('https://www.minderworks.com/login', '_self');
    },
    handleSelect(key, keyPath) {
      console.log(key);
      if (key == '10') {
        this.changeLanguage();
        return;
      }
      this.goUrl(key);
    },
    goUrl(index) {
      switch (index) {
        case '1':
          this.$router.push({
            path: 'main',
            query: {
              navIndex: index,
            },
          });
          break;

        // case 2:
        //   this.$router.push({
        //     path: 'service',
        //     query: {
        //       navIndex: index
        //     },
        //   });
        //   break;
        case '2':
          this.$router.push({
            path: 'quailty',
            query: {
              navIndex: index,
            },
          });
          break;
        case '3':
          this.$router.push({
            path: 'container',
            query: {
              navIndex: index,
            },
          });
          break;
        case '4':
          this.$router.push({
            path: '/vendor',
            query: {
              navIndex: index,
            },
          });
          break;
        case '5':
          this.$router.push({
            path: '/product',
            query: {
              navIndex: index,
            },
          });
          break;
        case '6':
          this.$router.push({
            path: '/fastStartN',
            query: {
              navIndex: index,
            },
          });
          break;
        case '7':
          this.$router.push({
            path: '/FQA',
            query: {
              navIndex: index,
            },
          });
          break;
        case '8':
          this.$router.push({
            path: '/contact',
            query: {
              navIndex: index,
            },
          });
          break;
      }
    },
    getNum() {
      this.$successAjax(
        api.msgNum,
        {},
        {
          method: 'get',
          appendToken: true,
        },
      ).then((data) => {
        let obj = data.data;
        this.total = obj.total;
      });
    },
    checkNameLength(str) {
      if (!str.length) return str;
      if (str.length > 15) {
        str = str.slice(0, 15) + '...';
      }

      return str;
    },
    quitLogin() {
      this.$alert('退出当前用户登录？', '退出', {
        confirmButtonText: '确定',
        callback: (action, instance) => {
          if (action == 'confirm') {
            this.$message({
              type: 'success',
              message: `已退出`,
            });
            localStorage.removeItem('logininfo');
            sessionStorage.removeItem('logininfo');
            this.loginFlag = false;
            if (
              this.$route.query.navIndex == 100 ||
              this.$route.query.navIndex == 1
            ) {
              this.$router.push({
                path: '/main',
                query: {},
              });
            } else {
              this.$router.go(0);
            }
          }
          // this.$router.go(0)
        },
      });
    },
    toLoginPage() {
      this.$router.push({
        path: '/login',
        query: {},
      });
    },
    toRegisterPage() {
      this.$router.push({
        path: '/register',
        query: {
          type: '1',
          index: 1,
        },
      });
    },
    toIndex(name) {
      this.index = name;
      this.$router.push({
        path: '/new_list',
        query: {
          navIndex: name,
        },
      });
    },
    toIndex1() {
      this.$router.push({
        name: 'main',
      });
    },
    toBack() {
      sessionStorage.setItem('enterType', 'login');
      window.open('./xzrc/index.html#/');
    },
    toHeatMap() {
      let { href } = this.$router.resolve({
        path: '/heatMap',
        query: { navIndex: 5 },
      });
      window.open(href, '_blank');
    },
    toMyInfo() {
      let { href } = this.$router.resolve({
        path: '/new_list',
        query: { navIndex: 100 },
      });
      window.open(href, '_blank');
    },
    goToBackIndex() {
      this.$successAjax(
        api.loginType,
        {},
        {
          method: 'get',
          appendToken: true,
        },
      ).then(({ data }) => {
        if (data.isAuth == 2) {
          sessionStorage.setItem('enterType', 'login');
          window.open('./xzrc/index.html#/');
        } else {
          let loginTypeLocal = localStorage.getItem('loginType');
          if (loginTypeLocal == 1) {
            sessionStorage.setItem('curModuleName', '用户中心(个人)');
            window.open('./xzrc/xz_talent_user.html#/');
          } else {
            sessionStorage.setItem('curModuleName', '用户中心');
            window.open('./xzrc/xz_enterprise_user.html#/');
          }
        }
      });
    },
    handleCommand(command) {
      if (command == 'a') {
        this.goToBackIndex();
      } else {
        this.quitLogin();
      }
    },
    setNum() {
      console.log(11);
      this.total = localStorage.getItem('msgNum');
    },
  },
};
</script>
<style  >
 ::v-deep .el-menu {
  background-color: #ffffff3b !important;
}
</style>
<style lang="less" scoped>
/deep/.el-submenu__title {
  font-size: 24px !important;
}
/deep/.el-menu-item {
  border-bottom: 0;

}
.el-menu--horizontal > .el-menu-item {
  margin-right: 50px !important;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
  background-color: transparent;
}
/deep/ .el-menu-item {
  font-size: 24px !important;
}
.head_bar {
  color: #000;
  height: auto;
  // width: 100%;
  position: static;
  display: grid;
  .m-head-nav {
    margin: 23px auto;
  }
}

li.m-head-nav-item {
  span {
    border-bottom: 2px solid transparent !important;
  }

  &:hover {
    color: #000 !important;

    span {
      border-bottom-color: #ff0000 !important;
    }
  }

  &:not(:last-child):after {
    //伪类分隔线
    content: '';
    margin-left: 10px;
    // border-left: 1px solid #ddd;
    height: 15px;
    position: absolute;
    top: 52px;
  }
}

li.curActiveLi {
  span {
    border-bottom-color: #ff0000 !important;
  }
}

// .m-head-nav ul.c-wrapper li.m-head-nav-item:not(:last-child):after {
//     content: "";
//     top: 52px;
// }
.cc_name {
  &:hover {
    color: #aaaeb7;
  }
}
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
/deep/ .el-dropdown-menu__item,
.el-menu-item {
  font-size: 20px;
  text-align: center;
  font-family: 'Avenir', Helvetica, Arial, sans-serif !important;
  
}
/deep/ .el-menu,
.el-menu--popup,
.el-menu--popup-bottom-start {
  border-radius: 9px !important;
  background: rgba(255,255,255,0.12);
}
/deep/ .el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  font-family: 'Avenir', Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased !important;
  background: rgba(255,255,255,0.12) !important;
}
.el-menu--horizontal .el-menu .el-menu-item{
  
  background: rgba(255,255,255,0.12);
  height: 48px;
}
/deep/ .el-menu--popup {
  background:rgba(255,255,255,0.12);
}
/deep/ .el-menu {
  background:'dsfsd' !important;
}
/deep/ .el-menu--horizontal{
  background: rgba(255,255,255,0.12) !important;

}
</style>
